import axiosInstance from "./axiosInstance";

// Get all topics
export const fetchAllBank = async () => {
    const response = await axiosInstance.get("/vietqr/getallbanks");
    return response.data;
};

export const fetchAllPrivateBank = async () => {
    const response = await axiosInstance.get("/vietqr/getprivateinfobanks");
    return response.data;
};

// Create a new topic
export const generateQRCode = async (request) => {
    const response = await axiosInstance.post("/vietqr/generate", request);
    return response.data;
};

